/**
 * <membership-jump target="membership" focus="membership-name">
 * When the page is opened with #membership (from any "become a member" link),
 * waits for images above to finish loading, then scrolls the signup form into
 * view and puts the cursor in the first field so visitors can start typing.
 */
class MembershipJump extends HTMLElement {
  connectedCallback() {
    this.onHashChange = () => this.jump();
    window.addEventListener('hashchange', this.onHashChange);
    if (window.location.hash !== `#${this.getAttribute('target')}`) return;
    if (document.readyState === 'complete') {
      this.jump();
    } else {
      this.onLoad = () => this.jump();
      window.addEventListener('load', this.onLoad, { once: true });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('hashchange', this.onHashChange);
    if (this.onLoad) window.removeEventListener('load', this.onLoad);
  }

  jump() {
    const targetId = this.getAttribute('target');
    if (window.location.hash !== `#${targetId}`) return;
    const target = document.getElementById(targetId);
    if (!target) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    const field = document.getElementById(this.getAttribute('focus'));
    if (field) field.focus({ preventScroll: true });
  }
}

if (!customElements.get('membership-jump')) customElements.define('membership-jump', MembershipJump);
